import { render } from "./TicketReply.vue?vue&type=template&id=a9a39daa&scoped=true"
import script from "./TicketReply.vue?vue&type=script&lang=js"
export * from "./TicketReply.vue?vue&type=script&lang=js"

import "./TicketReply.vue?vue&type=style&index=0&id=a9a39daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a39daa"]])

export default __exports__